import React from 'react';
import ClientForm from '@/forms/client/gp/lm';
import { SEGMENT } from '@/constants/constant';

const MobileLineClientForm = () => {
  return <ClientForm segment={SEGMENT.autonomos} />;
};
export default MobileLineClientForm;
